var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#5726DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 14H15C14.2044 14 13.4413 14.3161 12.8787 14.8787C12.3161 15.4413 12 16.2044 12 17V27C12 27.7956 12.3161 28.5587 12.8787 29.1213C13.4413 29.6839 14.2044 30 15 30H29C29.7956 30 30.5587 29.6839 31.1213 29.1213C31.6839 28.5587 32 27.7956 32 27V17C32 16.2044 31.6839 15.4413 31.1213 14.8787C30.5587 14.3161 29.7956 14 29 14ZM15 16H29C29.2652 16 29.5196 16.1054 29.7071 16.2929C29.8946 16.4804 30 16.7348 30 17L22 21.88L14 17C14 16.7348 14.1054 16.4804 14.2929 16.2929C14.4804 16.1054 14.7348 16 15 16ZM30 27C30 27.2652 29.8946 27.5196 29.7071 27.7071C29.5196 27.8946 29.2652 28 29 28H15C14.7348 28 14.4804 27.8946 14.2929 27.7071C14.1054 27.5196 14 27.2652 14 27V19.28L21.48 23.85C21.632 23.9378 21.8045 23.984 21.98 23.984C22.1555 23.984 22.328 23.9378 22.48 23.85L30 19.28V27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaile);
export default __webpack_public_path__ + "static/media/Maile.d0a760d3b5cc3fe5f4f909a091590ab9.svg";
export { ForwardRef as ReactComponent };